/**
 * Created by Jerker Nord on 2021-01-28.
 */
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Payday} from "../Payday";
import {gsap} from "gsap";

export class PaydayIdleNormalPresentation implements FlowStatePresentation {
    private static _tl:gsap.core.Timeline = gsap.timeline();
    public hasFinishedIntro:boolean;
    constructor() {
        this.hasFinishedIntro = false;
    }

    public start(flowStateController:FlowStateController) {
        PaydayIdleNormalPresentation._tl = gsap.timeline();

        PaydayIdleNormalPresentation._tl.add(() => {});
        PaydayIdleNormalPresentation._tl.add(() => {}, '>0.2');
        //BrickSnake2000IdleNormalPresentation.setupWinToggle();
        PaydayIdleNormalPresentation._tl.repeat(-1);

        flowStateController.setSkipCallback(()=>this.skip(flowStateController));

    }

    private skip(flowStateController:FlowStateController) {
        PaydayIdleNormalPresentation._tl.kill();
        //BrickSnake2000.baseGameReelView.getAllSymbols().forEach((sym) => sym.resetState());
        Payday.winView.clear();
        //BrickSnake2000.soundPlayer.stopSound("gameStartOneShot");
        flowStateController.finish();
    }
}